import { Box, Typography, Paper, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useAuth } from '../contexts/AuthContext';
import { QRCodeSVG } from 'qrcode.react';
import { useRef } from 'react';

export const QRPage = () => {
  const { userData } = useAuth();
  const publicUrl = `https://immunoworld.net/${userData?.url}`;
  const qrRef = useRef<HTMLDivElement>(null);

  const handleDownload = () => {
    // Verificar que el contenedor del QR existe
    if (!qrRef.current) return;
    
    // Obtener específicamente el SVG del QR dentro de nuestro contenedor
    const svg = qrRef.current.querySelector('svg');
    if (!svg) {
      console.error('No se pudo encontrar el SVG del QR');
      return;
    }
    
    // Crear un canvas temporal
    const canvas = document.createElement('canvas');
    const svgData = new XMLSerializer().serializeToString(svg);
    const img = new Image();
    
    // Convertir SVG a base64
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d')!;
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      
      // Convertir canvas a JPG y descargar
      const jpgUrl = canvas.toDataURL('image/jpeg');
      const link = document.createElement('a');
      link.download = 'mi-qr-immunocal.jpg';
      link.href = jpgUrl;
      link.click();
      
      // Limpiar
      URL.revokeObjectURL(url);
    };
    
    img.src = url;
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Mi Código QR
      </Typography>
      
      <Paper sx={{ p: 4, maxWidth: 400, mx: 'auto' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
          <Box ref={qrRef}>
            <QRCodeSVG value={publicUrl} size={300} />
          </Box>
          <Typography variant="body1" align="center">
            Este código QR dirige a tu página pública:
          </Typography>
          <Typography variant="body2" color="primary" sx={{ wordBreak: 'break-all' }}>
            {publicUrl}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            Comparte este código QR con tus contactos para que puedan acceder a tu espacio Immunocal
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
          >
            Descargar QR
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};
